import React from "react";

const ITEMS = [
  "Supreme Court of India",
  "High Courts",
  "CESTAT · ITAT · NCLT",
  "GST & Customs notifications",
  "CBIC & CBDT circulars",
  "Central & state Acts",
];

const CoverageStrip = () => (
  <section aria-label="Coverage" className="vd-section--tight">
    <div className="container vd-coverage">
      <span className="vd-eyebrow">RESEARCH ACROSS</span>
      {ITEMS.map((i) => (
        <span key={i}>{i}</span>
      ))}
    </div>
  </section>
);

export default CoverageStrip;
